import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';

import type { ComponentProps } from 'lib/component-props';
import withStyles from 'lib/enhancers/withStyles';

import styles from './Container70.module.scss';

const cx = classNames.bind(styles);

const Container70 = (props: ComponentProps): React.JSX.Element => {
  const { className, rendering } = props;

  return (
    <div className={cx('container-70', className)}>
      <div className={`container-70__col ${cx('container-70__col')}`}>
        <Placeholder key={0} name="hp-container-70-content" rendering={rendering} disableSuspense={true} />
      </div>
    </div>
  );
};

export default withStyles()<ComponentProps>(Container70);
